import { getCurrentToken } from '../services/getCurrentToken';
import { getAccessToken, getEnv, getRegion } from '../redux/selectors';
import { setAccessTokenAction, tokenExpired } from '../redux/actions';
import { ENV_CONFIGS } from '../constants/envs';

let latestPromise = null;

export const getToken = ({ getState, dispatch }) => {
  if (latestPromise) {
    return latestPromise;
  }
  const currentToken = getAccessToken(getState());
  const env = getEnv(getState());
  const region = getRegion(getState());
  const docsUrl = ENV_CONFIGS[region][env].DOCS;
  // in case this request was made in the last 20 seconds of the token to expire we want to get a new one.
  if (!currentToken || currentToken.expirationTime - Date.now() <= 30 * 1000) {
    latestPromise = getCurrentToken(docsUrl)
      .then(token => {
        latestPromise = null;
        dispatch(setAccessTokenAction(token));
        return token;
      })
      .then(token => token.token)
      .catch(() => {
        latestPromise = null;
        dispatch(tokenExpired());
      });
    return latestPromise;
  }

  return Promise.resolve(currentToken.token);
};
